import { render } from "./notice-modal.vue?vue&type=template&id=2db3560c&scoped=true"
import script from "./notice-modal.vue?vue&type=script&lang=js"
export * from "./notice-modal.vue?vue&type=script&lang=js"

import "./notice-modal.vue?vue&type=style&index=0&id=2db3560c&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db3560c"]])

export default __exports__